/**
 * Copyright (c) Qwoach LLC 2024. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7.06.24
 *
 */
import DbBaseObject from "@shared/DbBaseObject";
import Discriminator from "@/utils/Discriminator";
import {Type, plainToClass, classToPlain} from "@qwoach/class-transformer-wrapper"
import {ObjectTypeEnum} from "@shared/Invoice/ObjectTypeEnum";
import ClientEntryObjectData from "@shared/Workflow/base/ObjectData/ClientEntryObjectData";
import BaseEntryObjectData from "@shared/Workflow/base/ObjectData/BaseEntryObjectData";
import {ReminderItem} from "@shared/scheduler/reminders/reminderItem-imports";

const objectDataTypes = [
	{value: ClientEntryObjectData, name: ObjectTypeEnum.CLIENT},
]

const getClassByTypeName = (typeName) => {
	let type = objectDataTypes.find(type => type.name === typeName)
	if(type){
		return type.value
	}
	return BaseEntryObjectData
}

export default class WorkflowEntryItem extends DbBaseObject {

	title: string = null
	subtitle: string = null

	workflowIds: string[] = []
	stageId: string = null
	position: number = null

	objectId: string = null
	objectType: string = null

	@Type(() => BaseEntryObjectData, Discriminator.create(objectDataTypes))
	objectData: BaseEntryObjectData = new BaseEntryObjectData()

	@Type(() => ReminderItem)
	reminders: ReminderItem[] = []


	constructor() {
		super();
		this.position = WorkflowEntryItem.maxPosition()
	}

	setStageId(stageId){
		let res = this.stageId !== stageId
		this.stageId = stageId
		return res
	}

	setObjectType(objectType){
		this.objectType = objectType
		this.objectData.type = objectType

		let clazz = getClassByTypeName(objectType)
		let objectDataJson = classToPlain(this.objectData)
		this.objectData = plainToClass(clazz, objectDataJson)
	}

	setReminders(reminders){
		this.reminders = reminders
	}

	addWorkflowId(workflowId){
		this.workflowIds.pushUnique(workflowId)
	}
	removeWorkflowId(workflowId){
		let index = this.workflowIds.indexOf(workflowId)
		if(index >= 0){
			this.workflowIds.splice(index, 1)
		}
	}

	isPartOfAnyWorkflow(){
		return this.workflowIds.length > 0
	}

	static maxPosition(){
		return new Date().getTime() * 1000
	}

}
